var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { DossierInfo, DossierStep, useDossierContext, useDossierUpdateOrchestration } from 'common-app/dossier';
import { OverlayTrigger, Spinner, Tooltip } from '@isyc-react/design/bootstrap';
import { SignatoryForm, SignatorySummary } from './signatory-form.component';
import { FormProvider, RhfListForm, RhfListItemView, useForm, useWatch, } from '@isyc-react/form/modules/rhf';
import clsx from 'clsx';
import { signatoryApiToForm, signatoryFormToApi } from './signatory-form.mapper';
import { useMainSignatoryWriteMutationPromise } from 'common-app/api/query/main-signatory-write';
import { useSignatoryWriteMutationPromise } from 'common-app/api/query/signatory-write';
import { useSignatoryCreateMutationPromise } from 'common-app/api/query/signatory-create';
import { useErrorNotification } from '@isyc-react/form/modules/context/notification-hub';
import { useTranslation } from 'react-i18next';
import { namespaces } from 'i18n/i18n.constants';
const AddSignatory = props => {
    const { dossier } = useDossierContext();
    const { append, disabled } = props;
    const [loading, setLoading] = React.useState(false);
    const createSignatory = useSignatoryCreateMutationPromise();
    const addErrorNotification = useErrorNotification();
    return (React.createElement("div", { className: clsx('d-flex align-items-center font-size-14 fw-bold text-uppercase', {
            'cursor-pointer text-secondary': !loading && !disabled,
            'cursor-default text-muted': loading || disabled,
        }), onClick: () => {
            if (!loading && !disabled) {
                setLoading(true);
                createSignatory({ dossierId: dossier === null || dossier === void 0 ? void 0 : dossier.id })
                    .then(result => {
                    var _a;
                    const signatory = (_a = result.data) === null || _a === void 0 ? void 0 : _a.create_signatory;
                    if (signatory) {
                        append(signatoryApiToForm(signatory));
                    }
                })
                    .catch(err => {
                    addErrorNotification('Une erreur est survenue lors de la création du signataire', { life: 5000 });
                    console.error('Error', err);
                })
                    .finally(() => setLoading(false));
            }
        } },
        React.createElement("u", null,
            React.createElement("span", null, "+ "),
            React.createElement("span", null, "Ajouter un titulaire du bail")),
        loading && React.createElement(Spinner, { animation: 'border', size: 'sm', className: 'text-secondary ms-2' })));
};
export const SignatoryListFormContainer = props => {
    const { children, prepend, length, append, canAdd, loading } = props;
    const { t } = useTranslation(namespaces.common);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'd-flex align-items-center' },
            React.createElement("h3", { className: 'text-black fw-600 font-size-16' }, "Autres signataires")),
        length === 0 && React.createElement("div", null, "Il n'y a pas d'autres signataires"),
        children,
        canAdd && (React.createElement(React.Fragment, null,
            React.createElement("hr", { className: 'bg-dark-tertiary border-2' }),
            React.createElement("div", { className: 'row d-flex align-items-center mt-5 mb-4' },
                React.createElement("div", { className: 'col-12 col-sm mb-5 mb-sm-0' },
                    React.createElement(AddSignatory, { append: append, disabled: loading })),
                React.createElement("div", { className: 'col-12 col-sm-auto' },
                    React.createElement("div", { className: 'd-flex align-items-center justify-content-end' },
                        React.createElement("button", { type: 'submit', className: 'btn btn-secondary btn-lg btn-pill font-size-16 fw-500', disabled: loading },
                            React.createElement("div", { className: 'd-flex align-items-center justify-content-center' },
                                React.createElement("div", { className: 'me-2' }, "Passer \u00E0 la rubrique suivante"),
                                loading ? (React.createElement(Spinner, { animation: 'border', size: 'sm' })) : (React.createElement("i", { className: 'mdi mdi-check text-white font-size-16 d-block' }))))))),
            React.createElement("span", null, t('bailleurs.footer.card'))))));
};
export const DossierSignatories = props => {
    const { dossier } = useDossierContext();
    const { main, others } = props;
    const [loading, setLoading] = React.useState(false);
    const [updateStep] = useDossierUpdateOrchestration();
    const writeMainSignatory = useMainSignatoryWriteMutationPromise();
    const writeSignatories = useSignatoryWriteMutationPromise();
    const addErrorNotification = useErrorNotification();
    const methods = useForm({
        mode: 'onTouched',
        defaultValues: {
            main: signatoryApiToForm(main),
            others: others.map(signatoryApiToForm),
        },
    });
    const { handleSubmit, getValues, control } = methods;
    const onFormSuccess = (data) => __awaiter(void 0, void 0, void 0, function* () {
        const { main, others } = data;
        if (main && others) {
            setLoading(true);
            // TODO error notification and awaitableApollo ...
            yield writeMainSignatory({ dossierId: dossier === null || dossier === void 0 ? void 0 : dossier.id, participant: signatoryFormToApi(main) })
                .then(() => __awaiter(void 0, void 0, void 0, function* () {
                yield writeSignatories({ dossierId: dossier === null || dossier === void 0 ? void 0 : dossier.id, participants: others.map(o => signatoryFormToApi(o)) })
                    .then(() => __awaiter(void 0, void 0, void 0, function* () {
                    yield updateStep({ variables: { dossierId: dossier === null || dossier === void 0 ? void 0 : dossier.id, step: DossierStep.OCCUPANTS } });
                }))
                    .catch(err => {
                    addErrorNotification('Une erreur est survenue lors de la mise à jour des signataires', { life: 5000 });
                    console.error('Error', err);
                });
            }))
                .catch(err => {
                addErrorNotification('Une erreur est survenue lors de la mise à jour des signataires', { life: 5000 });
                console.error('Error', err);
            })
                .finally(() => setLoading(false));
        }
    });
    const onFormError = data => {
        addErrorNotification('Tous les champs obligatoires ne sont pas correctement renseignés', { life: 10000 });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DossierInfo, null),
        React.createElement("div", { className: 'px-5 px-md-0' },
            React.createElement("div", null,
                React.createElement("h1", { className: 'text-black fw-600 font-size-20 pt-5 pt-md-0' },
                    React.createElement("span", null, "Titulaire(s) du bail"),
                    React.createElement(OverlayTrigger, { delay: { show: 250, hide: 0 }, overlay: React.createElement(Tooltip, null, "Le ou les titulaires du bail sont celui ou ceux ayant sign\u00E9 le bail") },
                        React.createElement("i", { className: 'mdi mdi-information text-light-secondary ms-2' })))),
            React.createElement("p", { className: 'mb-0' }, "Vos informations sont pr\u00E9remplies avec les derni\u00E8res informations \u00E0 notre connaissance. Veuillez les valider, les compl\u00E9ter ou les modifier si votre situation a chang\u00E9."),
            React.createElement("p", { className: 'mb-0' }, "En fonction de votre d\u00E9claration, des justificatifs seront \u00E9ventuellement \u00E0 fournir. Les donn\u00E9es marqu\u00E9es avec un ast\u00E9risque * sont obligatoires.")),
        React.createElement(FormProvider, Object.assign({}, methods),
            React.createElement("div", { className: 'px-5 py-4' },
                React.createElement("form", { onSubmit: handleSubmit(onFormSuccess, onFormError) },
                    React.createElement("div", { className: 'row' },
                        React.createElement(SignatoryForm, { name: `main` })),
                    React.createElement("div", { className: 'mt-4' },
                        React.createElement(RhfListForm, { getValues: getValues, initialView: RhfListItemView.EXPANDED, sortable: true, newItemDefaultValue: null, removable: p => Boolean(p.erasable), rhf: { control, name: `others` }, Container: props => React.createElement(SignatoryListFormContainer, Object.assign({}, props, { loading: loading })), ItemTitle: ({ index, length }) => {
                                const surname = useWatch({ name: `others.${index}.surname` });
                                const firstname = useWatch({ name: `others.${index}.firstname` });
                                return React.createElement("div", { className: 'fw-bold' }, `Signataire : ${surname} ${firstname}`);
                            }, ItemSummaryView: SignatorySummary, ItemFormView: ({ index }) => (React.createElement(React.Fragment, null,
                                React.createElement("div", { className: 'row' },
                                    React.createElement(SignatoryForm, { name: `others.${index}` })))) })))))));
};
